// serviceService.js
import apiClient from '../services/api';

const serviceService = {
  getAllServices() {
    return apiClient.get('/services');
  },
  
  getService(id) {
    return apiClient.get(`/services/${id}`);
  },
  
  getServiceWithProducts(id) {
    return apiClient.get(`/services/${id}`);
  },
  
  createService(serviceData) {
    return apiClient.post('/services', serviceData);
  },
  
  updateService(id, serviceData) {
    return apiClient.put(`/services/${id}`, serviceData);
  },
  
  deleteService(id) {
    return apiClient.delete(`/services/${id}`);
  },
  
  // Product associations management
  associateProducts(serviceId, selectedProducts) {
    const details = selectedProducts
      .filter(item => item && item.product && item.product.Product_Name)
      .map(({ product, usage }) => ({
        product_name:  product.Product_Name,
        pack_qty:      parseFloat(product.qty)   || 1,
        price_inc_vat: parseFloat(product.price) || 0,
        usage:         parseFloat(usage)          || 0,
      }));
    return apiClient.put(`/services/${serviceId}/products`, { details });
  },
  
  updateProductUsage(serviceId, productId, usage) {
    return apiClient.put(`/services/${serviceId}/products/${productId}`, { usage });
  },
  
  removeProductFromService(serviceId, productId) {
    return apiClient.delete(`/services/${serviceId}/products/${productId}`);
  },
  
  removeServiceProducts(serviceId) {
    return apiClient.delete(`/services/${serviceId}/products`);
  },
  
  // Service details (for product associations)
  getServiceDetails() {
    return apiClient.get('/service-details');
  },
  
  // Calculate service pricing
  calculateServicePrice(serviceId, options = {}) {
    // Convert from camelCase to snake_case for Python backend
    const apiParams = {
      profit_margin: options.profit_margin !== undefined ? options.profit_margin : options.profitMargin,
      vat_rate: options.vat_rate !== undefined ? options.vat_rate : options.vatRate,
      include_products: options.include_products !== undefined ? options.include_products : options.includeProducts
    };
    
    console.log('Sending API request to calculate service price:', apiParams);
    return apiClient.post(`/services/${serviceId}/calculate`, apiParams);
  }
};

export default serviceService;